(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pc-home-discover"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-pc-home-content]').forEach(content => {
    const parent = content.closest('.pc-home-parent');
    if (!parent || parent.dataset.pcReady) return;
    const toggle = parent.querySelector(':scope > .pc-home-toggle');
    const panel = parent.querySelector(':scope > .submenu');
    if (!toggle || !panel) return;
    parent.dataset.pcReady = 'true';
    const desktop = matchMedia('(min-width: 1025px)');
    let closeTimer;
    let pinned = false;
    const setOpen = open => {
      if (!open) pinned = false;
      parent.dataset.pcOpen = String(open);
      toggle.setAttribute('aria-expanded', String(open));
      panel.inert = !open;
    };
    const reset = () => {
      setOpen(false);
      content.querySelectorAll('details').forEach(group => {
        group.open = desktop.matches;
        group.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
      });
    };
    toggle.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (desktop.matches && event.detail > 0 && parent.dataset.pcOpen === 'true' && !pinned) { pinned = true; return; }
      const open = parent.dataset.pcOpen !== 'true';
      setOpen(open);
      pinned = open;
    });
    parent.addEventListener('pointerenter', event => {
      clearTimeout(closeTimer);
      if (desktop.matches && event.pointerType === 'mouse') setOpen(true);
    });
    parent.addEventListener('pointerleave', () => {
      if (desktop.matches) closeTimer = setTimeout(() => {
        if (!pinned && !parent.contains(document.activeElement)) setOpen(false);
      }, 180);
    });
    parent.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopPropagation(); setOpen(false); toggle.focus();
      } else if (event.key === 'ArrowDown' && !panel.contains(event.target)) {
        event.preventDefault(); setOpen(true);
        const target = desktop.matches ? content.querySelector('a') : content.querySelector('summary');
        target?.focus();
      }
    });
    parent.addEventListener('focusout', () => setTimeout(() => {
      if (!parent.contains(document.activeElement) && !parent.matches(':hover')) setOpen(false);
    }, 0));
    document.addEventListener('click', event => {
      if (!parent.contains(event.target) || event.target.closest('.close-menu')) setOpen(false);
    });
    desktop.addEventListener('change', reset);
    reset();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
